export default __webpack_public_path__ + "static/media/skippedmeal_4@2x.9684f5fe.jpg";